import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ContactUs.css';
import { ApiContext } from '../context/ApiContext';

const ContactUs = () => {
    const navigate = useNavigate();
    const apiUrl = useContext(ApiContext);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [emailError, setEmailError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setEmailError('');
        setLoading(true);

        if (!email || !/^[^@]+@[^@]+\.[^@]+$/.test(email)) {
            setEmailError('Please enter a valid email address');
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${apiUrl}/api/v1/contact-us`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, subject, message }),
            });

            if (response.ok) {
                setSubmitted(true);
            } else {
                const data = await response.json().catch(() => null);
                setError(data?.message || 'Something went wrong. Please try again.');
            }
        } catch (err) {
            setError('Unable to connect. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="ContactUs">
                <div className="contact-us-card">
                    <div className="contact-us-success-icon">✉️</div>
                    <h2>Message Sent!</h2>
                    <p className="contact-us-success-message">
                        Thank you for reaching out. We've received your message and will get back to you as soon as possible.
                    </p>
                    <button
                        className="contact-us-home-btn"
                        onClick={() => navigate('/')}
                    >
                        Back to Homepage
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="ContactUs">
            <div className="contact-us-card">
                <h2>Contact Us</h2>
                <p className="contact-us-subtitle">
                    Have a question or feedback? We'd love to hear from you.
                </p>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label>Name <span className="contact-us-required">*</span></label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Your name"
                            required
                            autoComplete="name"
                        />
                    </div>
                    <div>
                        <label>Email <span className="contact-us-required">*</span></label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            required
                            autoComplete="email"
                        />
                        {emailError && <p className="contact-us-error">{emailError}</p>}
                    </div>
                    <div>
                        <label>Subject <span className="contact-us-required">*</span></label>
                        <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            placeholder="What is this about?"
                            required
                        />
                    </div>
                    <div>
                        <label>Message <span className="contact-us-required">*</span></label>
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Your message…"
                            rows={6}
                            required
                        />
                    </div>
                    {error && <p className="contact-us-error">{error}</p>}
                    <button
                        type="submit"
                        className="contact-us-submit-btn"
                        disabled={loading}
                    >
                        {loading ? 'Sending…' : 'Send Message'}
                    </button>
                </form>
                <button
                    className="contact-us-back-link"
                    onClick={() => navigate('/')}
                >
                    ← Back to Homepage
                </button>
            </div>
        </div>
    );
};

export default ContactUs;
